/**
 * The white bordered panel every expanded-row section sits in (prototype
 * `.panel`): a small uppercase heading, then the content. Semantic tokens only.
 */
import type { ReactNode } from 'react';
import { Text } from '@clay-run/glaze/text';

export function DetailPanel({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section aria-label={title} className="rounded-lg border border-border-secondary bg-bg-primary p-3">
      <Text size="xs" weight="semibold" variant="tertiary" className="mb-2 uppercase tracking-wide">
        {title}
      </Text>
      {children}
    </section>
  );
}
